<script setup>
import {ref, onMounted, watch, computed, getCurrentInstance, toRaw, onBeforeUnmount, inject, defineExpose} from 'vue'
import { useRoute, useRouter } from 'vue-router'
import SNB from '../../../../../layouts/nav/SNB.vue'
import {usePageLoadingStore} from "../../../../../stores/pageLoading";
import {useUserStore} from "../../../stores/user";
import JobFairResumeOpenModal from "../../../components/modal/jobFair/JobFairResumeOpenModal.vue";
import LecturePlayerModal from "../../../components/modal/mypage/LecturePlayerModal.vue";
import LectureResumeModal from "../../../components/modal/mypage/MyPageResumeModal.vue";
import LectureSurveyModal from "../../../components/modal/mypage/LectureSurveyModal.vue";
import KSASecondaryButton from "../../../../../components/ui-components/button/KSASecondaryButton.vue";
import jobFairUserService from "../../../services/jobFair/jobFairUserService";
import KSATextButton from "../../../../../components/ui-components/button/KSATextButton.vue";
import KSAPrimaryButton from "../../../../../components/ui-components/button/KSAPrimaryButton.vue";
import JobFairResumeModal from "@/pages/user/components/modal/jobFair/JobFairResumeModal.vue";
import JobFairJobNoticeModal from "@/pages/user/components/modal/jobFair/JobFairJobNoticeModal.vue";
import JobFairCorpInfoModal from "@/pages/user/components/modal/jobFair/JobFairCorpInfoModal.vue";
import _ from "lodash";
import JobFairResumeListModal from "@/pages/user/components/modal/jobFair/JobFairResumeListModal.vue";
import JobFairApplyResumeModal from "@/pages/user/components/modal/jobFair/JobFairApplyResumeModal.vue";
import JobFairApplyResumeConfirmModal from "@/pages/user/components/modal/jobFair/JobFairApplyResumeConfirmModal.vue";
import { useAlertStore } from '../../../../../stores/alertStore';
const { $alert, $confirm } = useAlertStore();

const route = useRoute()
const router = useRouter()
const loadingStore = usePageLoadingStore()
const { user, isAuthenticated } = useUserStore()
const { $pageListBoardNo } = getCurrentInstance().appContext.config.globalProperties;

const JOB_FAIR = 'JOB_FAIR';
const ENTRY_UPDATE = 'ENTRY_UPDATE'; // 참가신청 정보 관리 수정
const RETRIEVE_APPLICANT = 'RETRIEVE_APPLICANT'; // 입사지원
const JOB_NOTICE_LIST = 'JOB_NOTICE_LIST'; // 채용 공고

onBeforeUnmount(()=>{
  localStorage.removeItem('data-lect-cert');
})

onMounted( ()=>{

  const { id } = route.params;
  if(!id) {
    router.push({name: 'MyPageOpenRecruitment'})
  } else {
    // loadingStore.loading = true;
    const p1 = ojfDetailByIdAndUserId(id)
    Promise.all([p1])
    .then( async (res) => {
      loadingStore.loading = false;
      if(res[0].data.code.toLowerCase() === 'success'){
        const result = res[0].data.result;
        jobDetail.value = result;

        ojfIntvDay(jobDetail.value.ojfId); // 면접 가능일 조회
      }
    })
    _.each(intvDays.value, el => {el.on = false;})
  }
})

const viewMode = ref(JOB_FAIR); // JOB_FAIR

const jobDetail = ref({}) // 특별채용관 상세

const entryDetail = ref({ // 참가신청 정보
  "joinPurpose": '',
  "intvInYn": '',
  "intvAbleDay": '',
})
const entryUpdate = ref({}) // 참가신청 수정
const resumeList = ref([]); // 이력서 관리 및 입사지원 현황 리스트
const applicantList = ref([]);// 입사지원 리스트
const interestCorpList = ref([]); // 관심 기업 리스트
const interestNoticeList = ref([]); // 관심 공고 리스트
const proposalList = ref([]); // 받은 면접제안 리스트
const jobNoticeList = ref([]); // 채용공고

const intvDays = ref([]); // 면접 가능일
const isAllActive = ref(false); // 면접일 전체
const isEtcActive = ref(false); // 면접일 외 일정

const currentPage = ref(1);
const pageSize = ref(10);
const totalPages = ref(1);
const totalCount = ref(0);

const currentPageDepth2 = ref(1); // 입사지원 현황 페이지
const totalPagesDepth2 = ref(1); // 입사지원 현황 총 페이지
const totalCountDepth2 = ref(0); // 입사지원 현황 총 개수

const detailCommonId = ref(''); // resumeId / corpId
const detailResOpenYn = ref(''); //resOpenYn
const fileYns = ref(''); // fileYn

const pageSizeGroup = ref([
  { label:"10개씩 보기", value: 10 },
  { label:"30개씩 보기", value: 30 },
  { label:"50개씩 보기", value: 50 },
  { label:"100개씩 보기", value: 100 },
])

const tabOptions = ref([
  {label:'행사정보', value: 0},
  {label:'참가신청 정보 관리', value: 1},
  {label:'이력서 관리 및 입사지원 현황', value: 2},
  {label:'관심 기업', value: 3},
  {label:'관심 공고', value:4},
  {label:'받은 면접제안', value: 5},
]);
const tabIndex = ref(0)

const entryInputError = ref({
  joinPurpose: '',
  intvAbleDay: '',
})

// 모달
const jobFairResumeOpenModal = ref(null)
const lecturePlayerModal = ref(null)
const lectureResumeModal = ref(null)
const lectureSurveyModal = ref(null)
const jobFairResumeModal = ref(null) // 이력서
const jobNoticeModal = ref(null); // 채용공고
const corpInfoModal = ref(null); // 기업정보
const resumeListModal = ref(null); // 이력서 보기
const applyResumeConfirmModal = ref(null); // 회사 이력서 안내
const applyResumeModal = ref(null); // 회사 이력서 입사지원

// 기업공채관 상세 조회
const ojfDetailByIdAndUserId = (id) => {
  return jobFairUserService.ojfDetailByIdAndUserIdForMyPage(id);
}

// 탭 비활성화 여부 확인
const isDisabled = (tab) => {
  if (jobDetail.value.joinStateGb === '11') {
    return false; // 11일 때는 모두 활성화
  } else {
    return ![0, 1, 2].includes(tab.value);
  }
};

const onSelectTab = (option) => {
  if (!isDisabled(option)) {
    tabIndex.value = option.value;
    currentPage.value = 1;
    currentPageDepth2.value = 1;
  }

  if (tabIndex.value === 1) { // 참가신청 정보 관리
    ojfDetailEntryListByIdAndUserId();
    ojfIntvDay(jobDetail.value.ojfId); // 면접 가능일 조회
    setViewMode('JOB_FAIR')
  } else if (tabIndex.value === 2) { // 이력서 관리 및 입사지원 현황
    ojfResumeList();
    setViewMode('JOB_FAIR')
  } else if(tabIndex.value === 3) { // 관심 기업
    ojfInterestCorpList();
    setViewMode('JOB_FAIR')
  }  else if (tabIndex.value === 4) { // 관심 공고
    ojfInterestJobNoticeList();
    setViewMode('JOB_FAIR')
  } else {
    ojfInterestProposalList();
    setViewMode('JOB_FAIR')
  }
}

// 페이징 개수 변경
const onSelectPageSize = (option) => {
  pageSize.value = option.value;
  currentPage.value = 1;
  currentPageDepth2.value = 1;
  
  if(tabIndex.value === 2) { // 이력서 관리 및 입사지원 현황
    ojfResumeList();
    pageSize.value = 10;
  } else if(tabIndex.value === 3) { // 관심 기업
    ojfInterestCorpList();
    pageSize.value = 10;
  } else if (tabIndex.value === 4) { // 관심 공고
    ojfInterestJobNoticeList();
    pageSize.value = 10;
  } else {
    ojfInterestProposalList();
    pageSize.value = 10;
  }
}

// 페이지 클릭
const onSelectPage = (pageNo, depth) => {
  if(depth === 2) {
    currentPageDepth2.value = pageNo;
  } else {
    currentPage.value = pageNo;
  }

  if(tabIndex.value === 2) { // 이력서 관리 및 입사지원 현황
    if(viewMode.value === RETRIEVE_APPLICANT) {
      retrieveApplicantList(detailCommonId.value);
    } else {
      ojfResumeList();
    }
  } else if(tabIndex.value === 3) { // 관심 기업
    if(viewMode.value === JOB_NOTICE_LIST) {
      ojfJobNoticeList(detailCommonId.value);
    } else {
      ojfInterestCorpList();
    }
  } else if (tabIndex.value === 4) { // 관심 공고
    ojfInterestJobNoticeList();
  } else {
    ojfInterestProposalList();
  }
}

// 탭 상세 화면 보기 조건
const setViewMode = (viewName, commonId, resOpenYn, fileYn) => {
  viewMode.value = viewName;
  // 이력서 관리 및 입사지원 현황 > 입사지원 : resumeId 외 다른 데이터 사용
  // 관심 기업 > 채용공고 : corpId만 사용
  detailCommonId.value = commonId; // resumeId / corpId
  detailResOpenYn.value = resOpenYn;

  ojfIntvDay(jobDetail.value.ojfId); // 면접 가능일 조회
  if(viewName === ENTRY_UPDATE) {
    // 선택한 면접 날짜 가져오기
    const selectedDays = entryDetail.value.intvAbleDay?.split(',').map(day => day.trim()) || []

    setTimeout(() => {
      // 면접 가능 전체 날짜
      const allLabels = intvDays.value.map(day => day.label)

      if (entryDetail.value.intvInYn === 'Y') {
        // 면접 가능일내 날짜

        // "전체" 선택 여부 판단
        const isAll = selectedDays.length === allLabels.length &&
            selectedDays.every(day => allLabels.includes(day))

        if (isAll) {
          onClickAll(true);
        } else {
          isAllActive.value = false
          isEtcActive.value = false
          entryDetail.value.intvInYn = 'Y'

          intvDays.value.forEach(day => {
            day.on = selectedDays.includes(day.label)
          })
        }
      } else {
        // 그 외
        onClickEtc(true)
      }
    }, 100)
  } else if (viewName === 'RETRIEVE_APPLICANT') {
    currentPageDepth2.value = 1;
    retrieveApplicantList(commonId);
    fileYns.value = fileYn;
  } else if (viewName === 'JOB_NOTICE_LIST') {
    currentPageDepth2.value = 1;
    ojfJobNoticeList(commonId);
  } else {
  }
}

// s : 참가신청 정보 관리
// 상세
const ojfDetailEntryListByIdAndUserId = () => {
  loadingStore.loading = true;
  jobFairUserService.ojfDetailEntryListByIdAndUserId(jobDetail.value.ojfId)
      .then( async (res) => {
        loadingStore.loading = false;
        if(res.data.code.toLowerCase() === 'success') {
          const result = res.data.result;
          entryDetail.value = result;
        }
      }).catch( (error) =>  {
    console.log(error);
    loadingStore.loading = false;
  });
}

// 면접 가능일 전체인지 확인 후 문구 표시
// 참가신청 정보 관리
const allDays = computed(() => entryDetail.value.intvAbleDay.split(','))
const isAllSelected = computed(() => intvDays.value.length === allDays.value.length)
// 이력서 관리 및 입사지원 현황 > 입사지원
const allDays2 = computed(() => applicantList.value.flatMap(item => item.intvAbleDay.split(',')))
const isAllSelected2 = computed(() => intvDays.value.length === allDays2.value.length)
// 관심기업 > 채용공고
const allDays3 = computed(() => jobNoticeList.value.flatMap(item => item.intvAbleDay.split(',')))
const isAllSelected3 = computed(() => intvDays.value.length === allDays3.value.length)
// 관심 공고
const allDays4 = computed(() => interestNoticeList.value.flatMap(item => item.intvAbleDay.split(',')))
const isAllSelected4 = computed(() => intvDays.value.length === allDays4.value.length)
// 받은 면접제안
const allDays5 = computed(() => proposalList.value.flatMap(item => item.intvAbleDay.split(',')))
const isAllSelected5 = computed(() => intvDays.value.length === allDays5.value.length)

// 신청 취소 버튼
const cancelEntry = async (entrySeq, joinStateGb) => {
  const ok = await $confirm(["'신청 취소'로 상태가 변경됩니다."], "신청 취소");
  if(!ok) {
    return -1;
  }

  let paramObj = {
    ojfId: jobDetail.value.ojfId,
    entrySeq: entrySeq,
    joinStateGb: joinStateGb,
  }
  jobFairUserService.ojfUpdateEntryJoinStateByUserId(paramObj)
      .then( async (res) => {
        loadingStore.loading = false;
        if(res.data.code.toLowerCase() === 'success') {
          $alert("참가 신청이 취소 되었습니다.");
          router.push({name: 'MyPageOpenRecruitment'})
        }
      }).catch( (error) =>  {
    loadingStore.loading = false;
    console.log(error);
  });
}

// 참가 신청 수정
// 면접 가능일 조회
const ojfIntvDay = (ojfId) => {
  loadingStore.loading = true;
  jobFairUserService.ojfIntvDay(ojfId)
      .then( async (res) => {
        loadingStore.loading = false;
        if(res.data.code.toLowerCase() === 'success') {
          const result = res.data.result;
          if (result !== null && result !== '') {
            const selectedDays = result.split(',').map(d => d.trim());

            intvDays.value = selectedDays.map(day => ({
              label: day,
              on: false
            }));
          }
        }
      }).catch( (error) =>  {
    console.log(error);
    loadingStore.loading = false;
  });
}

// 면접 가능일 클릭
const onClickIntvDay = (clickedDay) => {
  entryInputError.value.intvAbleDay = '';
  isEtcActive.value = false
  entryDetail.value.intvInYn = 'Y';

  if (isAllActive.value) {
    // 전체 모드 해제 → 클릭한 날짜만 on
    isAllActive.value = false
    entryDetail.value.intvInYn = 'Y';

    intvDays.value.forEach(day => {
      day.on = (day === clickedDay)
    })
  } else {
    // 전체 상태가 아닐 때는 토글만
    clickedDay.on = !clickedDay.on

    // 날짜 전체가 선택되었는지 확인
    const allSelected = intvDays.value.every(day => day.on)
    isAllActive.value = allSelected
  }
}

// 면접 가능일 전체
const onClickAll = (force) => {
  entryInputError.value.intvAbleDay = ''

  if (isAllActive.value && !force) {
    isAllActive.value = false
    isEtcActive.value = false
    entryDetail.value.intvInYn = 'Y';

    intvDays.value.forEach(day => {
      day.on = false
    })
  } else {
    isAllActive.value = true
    isEtcActive.value = false
    entryDetail.value.intvInYn = 'Y';

    intvDays.value.forEach(day => {
      day.on = true
    })
  }
}

// 면접 가능일 외
const onClickEtc = (force) => {
  entryInputError.value.intvAbleDay = ''

  if (isEtcActive.value && !force) {
    isEtcActive.value = false
    entryDetail.value.intvInYn = 'Y'
  } else {
    isEtcActive.value = true
    isAllActive.value = false
    entryDetail.value.intvInYn = 'N'

    intvDays.value.forEach(day => {
      day.on = false
    })
  }
}

// 참가 신청 수정
const ojfUpdateEntry = () => {
  let isInvalid = false;
  const ojfId = jobDetail.value.ojfId;

  // 참가 목적
  const { joinPurpose } = entryDetail.value;
  entryInputError.value.joinPurpose = '';

  // ella : 참가 목적 숨김 요청 (20250904)
  // if(!joinPurpose) {
  //   entryInputError.value.joinPurpose = '참가 목적을 입력하세요.';
  //   isInvalid = true;
  // }

  // 면접 가능일
  const intvAbleDay = _.map(_.filter(intvDays.value, {'on': true}), 'label').join(',');

  const { intvInYn } = entryDetail.value;
  entryInputError.value.intvAbleDay = '';

  if(!intvInYn) {
    entryInputError.value.intvAbleDay = '면접 가능일을 선택하세요.';
    isInvalid = true;
  } else if (intvInYn === 'Y' && !intvAbleDay) {
    entryInputError.value.intvAbleDay = '면접 가능일을 선택하세요.';
    isInvalid = true;
  }

  // 저장 처리
  if (isInvalid) {
    $alert("필수 입력사항을 확인해 주세요.");
    isInvalid = true;
  } else {
    loadingStore.loading = true;
    jobFairUserService.ojfUpdateEntry(
      ojfId, joinPurpose, intvInYn, intvAbleDay,
    ) .then( async (res) => {
          loadingStore.loading = false;
          if(res.data.code.toLowerCase() === 'success') {
            const result = res.data.result;
            // console.log(result);
            entryUpdate.value = result;
            $alert("수정 완료되었습니다.");
            setViewMode(JOB_FAIR);
            ojfDetailEntryListByIdAndUserId();
          }
        }).catch( (error) =>  {
      // console.log(error);
      loadingStore.loading = false;
    });
  }
}

// 참가 신청 수정 취소
const cancelUpdateEntry = async () => {
  setViewMode(JOB_FAIR);
  ojfDetailEntryListByIdAndUserId();
  $alert("수정이 취소되었습니다.");
}
// e : 참가신청 정보

// s : 이력서 관리 및 입사지원 현황
// 목록
const ojfResumeList = () => {
  let paramObj = {
    ojfId: jobDetail.value.ojfId,
    pageNumber: currentPage.value || 0,
    size: pageSize.value || 10,
  }

  // loadingStore.loading = true;
  jobFairUserService.ojfResumeList(paramObj)
      .then( (res) => {
        if(res.data.code.toLowerCase() === 'success') {
          const result = res.data.result;
          // console.log(result);
          totalPages.value = result.totalPages;
          totalCount.value = result.totalElements;
          resumeList.value = $pageListBoardNo(result.content, totalCount.value, pageSize.value, currentPage.value);
          const firstId = resumeList.value.length > 0 ? resumeList.value[0].ojfId : null;
        }
      }).catch( (error) =>  {
    console.log(error);
    loadingStore.loading = false;
  });
}

// 인재정보 공개 여부
const onClickChangeResOpenYn = async (resumeId, resOpenYn) => {
  let ok = false;
  // 기존에 오픈된 이력서 존재 여부 확인. true/false
  const resumeY = resumeList.value.some(item => item.resOpenYn === 'Y');

  // resOpenYn Y인지 아닌지 check
  if (resOpenYn === 'Y') { // 공개
    if (resumeList.value.length > 1) { // 이력서가 여러개 일때
      if (resumeY) { // 오픈된 기존 이력서가 존재할 경우
        jobFairResumeOpenModal.value.init('openRecruitment')
        ok = await jobFairResumeOpenModal.value.show(false);
      } else { // 오픈된 기존 이력서가 존재하지 않을 경우
        ok = await $confirm(["해당 이력서를 공개 하시겠습니까?"]);
      }
    } else {
      ok = await $confirm(["해당 이력서를 공개 하시겠습니까?"]);
    }
  } else { //비공개
    ok = await $confirm(["해당 이력서를 비공개 하시겠습니까?"]);
  }

  // if ( resumeList.value.length > 1 && resumeY ) {
  //   const result = await jobFairResumeOpenModal.value.show(false);
  //
  //   if (result === true) {
  //
  //     modalContent.value = ["선택한 이력서가", "기업공채관 인재정보에 공개되었습니다."];
  //     okButtonText.value = "확인";
  //
  //     ok = await modal.value.show();
  //   }
  // } else if (resumeY) {
  //   modalContent.value = ["선택한 이력서가", "기업공채관 인재정보에 비공개되었습니다."];
  //   okButtonText.value = "확인";
  //
  //   ok = await modal.value.show();
  // } else {
  //   modalContent.value = ["선택한 이력서가", "기업공채관 인재정보에 공개되었습니다."];
  //   okButtonText.value = "확인";
  //
  //   ok = await modal.value.show();
  // }

  if ( ok ) {
    let paramObj = {
      resumeId: resumeId,
      ojfId: jobDetail.value.ojfId,
      resOpenYn: resOpenYn,
    }
    jobFairUserService.ojfResumeResOpenYn(paramObj)
        .then(async (res) => {
          loadingStore.loading = false;
          if (res.data.code.toLowerCase() === 'success') {
            //let result = res.data.result;
            //console.log(result);
            if (resOpenYn === 'Y') {
              $alert("선택한 이력서가 기업공채관 인재정보에 공개되었습니다.");
            } else if (resOpenYn === 'N') {
              $alert("선택한 이력서가 기업공채관 인재정보에 비공개되었습니다.");
            }
            ojfResumeList();
          }
        }).catch((error) => {
      loadingStore.loading = false;
      console.log(error);
    });
  }
}

// 입사지원 목록
const retrieveApplicantList = (resumeId) => {
  let paramObj = {
    resumeId: resumeId,
    ojfId: jobDetail.value.ojfId,
    pageNumber: currentPageDepth2.value || 0,
    size: pageSize.value || 10,
  }

  // loadingStore.loading = true;
  jobFairUserService.retrieveApplicantList(paramObj)
      .then( (res) => {
        if(res.data.code.toLowerCase() === 'success') {
          const result = res.data.result;
          // console.log(result);
          totalPagesDepth2.value = result.totalPages;
          totalCountDepth2.value = result.totalElements;
          applicantList.value = $pageListBoardNo(result.content, totalCountDepth2.value, pageSize.value, currentPageDepth2.value);
        }
      }).catch( (error) =>  {
    console.log(error);
    loadingStore.loading = false;
  });
}

// 입사지원 상태변경
const onClickApplyStateGb = async (resumeId, jobNoticeSeq, stateGb) => {

  if (stateGb === "01") {
    stateGb = "02"
  }
  const ok = await $confirm(["지원을 취소 하시겠습니까?", "'지원취소'로 상태가 변경됩니다."], "지원 취소");
  if(!ok) {
    return -1;
  } else {
    let paramObj = {
      resumeId: resumeId,
      ojfId: jobDetail.value.ojfId,
      jobNoticeSeq: jobNoticeSeq,
      applyStateGb: stateGb,
    }
    jobFairUserService.ojfUpdateApplyStateGb(paramObj)
        .then( (res) => {
          loadingStore.loading = false;
          if(res.data.code.toLowerCase() === 'success') {
            //const result = res.data.result;
            $alert("변경 하였습니다.");
            //$toast('', "삭제를 하였습니다.")
            retrieveApplicantList(resumeId);
          } else {
            $alert("변경을 실패하였습니다.");
            console.log(res);
          }
        }).catch( (res) =>  {
      loadingStore.loading = false;
      $alert("변경을 실패하였습니다.");
    });
  }
}
// e : 이력서 관리 및 입사지원 현황


// s : 관심 기업
// 목록
const ojfInterestCorpList = () => {
  let paramObj = {
    ojfId: jobDetail.value.ojfId,
    pageNumber: currentPage.value || 0,
    size: pageSize.value || 10,
  }

  // loadingStore.loading = true;
  jobFairUserService.ojfInterestCorpList(paramObj)
      .then( (res) => {
        if(res.data.code.toLowerCase() === 'success') {
          const result = res.data.result;
          // console.log(result);
          totalPages.value = result.totalPages;
          totalCount.value = result.totalElements;
          interestCorpList.value = $pageListBoardNo(result.content, totalCount.value, pageSize.value, currentPage.value);
        }
      }).catch( (error) =>  {
    console.log(error);
    loadingStore.loading = false;
  });
}

// 관심 기업 관심여부
const onClickCorpEntryYn = async (corpId) => {
  const ok = await $confirm(["관심기업을 삭제하시겠습니까?"], "관심기업 삭제");
  if(!ok) {
    return -1;
  } else {
    let paramObj = {
      ojfId: jobDetail.value.ojfId,
      corpId: corpId,
      interestYn: "N",
    }
    jobFairUserService.ojfInterestCorpEntryYn(paramObj)
        .then( (res) => {
          loadingStore.loading = false;
          if(res.data.code.toLowerCase() === 'success') {
            $alert("삭제를 하였습니다.");
            ojfInterestCorpList();
          } else {
            $alert("삭제를 실패하였습니다.");
            console.log(res);
          }
        }).catch( (res) =>  {
      loadingStore.loading = false;
      $alert("삭제를 실패하였습니다.");
      console.log(res);
    });
  }
}

// 채용공고 목록
const ojfJobNoticeList = (corpId) => {
  let paramObj = {
    ojfId: jobDetail.value.ojfId,
    corpId: corpId,
    pageNumber: currentPageDepth2.value || 0,
    size: pageSize.value || 10,
  }
  // loadingStore.loading = true;
  jobFairUserService.ojfJobNoticeList(paramObj)
      .then( (res) => {
        if(res.data.code.toLowerCase() === 'success') {
          const result = res.data.result;
          // console.log(result);
          totalPagesDepth2.value = result.totalPages;
          totalCountDepth2.value = result.totalElements;
          jobNoticeList.value = $pageListBoardNo(result.content, totalCountDepth2.value, pageSize.value, currentPageDepth2.value);
        }
      }).catch( (error) =>  {
    console.log(error);
    loadingStore.loading = false;
  });
}
// e : 관심 기업

// s : 관심 공고
// 목록
const ojfInterestJobNoticeList = () => {
  let paramObj = {
    ojfId: jobDetail.value.ojfId,
    pageNumber: currentPage.value || 0,
    size: pageSize.value || 10,
  }

  // loadingStore.loading = true;
  jobFairUserService.ojfInterestJobNoticeList(paramObj)
      .then( (res) => {
        if(res.data.code.toLowerCase() === 'success') {
          const result = res.data.result;
          // console.log(result);
          totalPages.value = result.totalPages;
          totalCount.value = result.totalElements;
          interestNoticeList.value = $pageListBoardNo(result.content, totalCount.value, pageSize.value, currentPage.value);
        }
      }).catch( (error) =>  {
    console.log(error);
    loadingStore.loading = false;
  });
}

// 관심공고 관심여부
const onClickNoticYn = async (jobNoticeSeq) => {
  const ok = await $confirm(["관심공고을 삭제하시겠습니까?"], "관심공고 삭제");
  if(!ok) {
    return -1;
  } else {
    let paramObj = {
      ojfId: jobDetail.value.ojfId,
      jobNoticeSeq: jobNoticeSeq,
      interestNoticeYn: "N",
    }
    jobFairUserService.ojfInterestNoticeYn(paramObj)
        .then( (res) => {
          loadingStore.loading = false;
          if(res.data.code.toLowerCase() === 'success') {
            $alert("삭제를 하였습니다.");
            ojfInterestJobNoticeList();
          } else {
            $alert("삭제를 실패하였습니다.");
          }
        }).catch( (res) =>  {
      loadingStore.loading = false;
      $alert("삭제를 실패하였습니다.");
    });
  }
}
// e : 관심 공고

// s : 받은 면접제안
// 목록
const ojfInterestProposalList = () => {
  let paramObj = {
    ojfId: jobDetail.value.ojfId,
    pageNumber: currentPage.value || 0,
    size: pageSize.value || 10,
  }

  // loadingStore.loading = true;
  jobFairUserService.ojfInterestProposalList(paramObj)
      .then( (res) => {
        if(res.data.code.toLowerCase() === 'success') {
          const result = res.data.result;
          // console.log(result);
          totalPages.value = result.totalPages;
          totalCount.value = result.totalElements;
          proposalList.value = $pageListBoardNo(result.content, totalCount.value, pageSize.value, currentPage.value);
        }
      }).catch( (error) =>  {
    console.log(error);
    loadingStore.loading = false;
  });
}

// 받은 면접제안 상태변경
const onClickIntvPropState = async (resumeId, jobNoticeSeq, stateGb) => {
  let ok;
  if (stateGb === '02') {
    ok = await $confirm(["면접 제안을 수락하시겠습니까?", "'제안수락'으로 상태가 변경됩니다."], "제안 수락");
  } else {
    ok = await $confirm(["면접 제안을 거절하시겠습니까?", "'제안거절'로 상태가 변경됩니다."], "제안 거절");
  } 
  if(!ok) {
    return -1;
  } else {
    let paramObj = {
      resumeId: resumeId,
      jobNoticeSeq: jobNoticeSeq,
      intvPropStateGb: stateGb,
    }
    jobFairUserService.ojfUpdateIntvPropsState(paramObj)
        .then( (res) => {
          loadingStore.loading = false;
          if(res.data.code.toLowerCase() === 'success') {
            $alert("변경 하였습니다.");
            ojfInterestProposalList();
          } else {
            $alert("변경을 실패하였습니다.");
          }
        }).catch( (res) =>  {
      loadingStore.loading = false;
      $alert("변경을 실패하였습니다.");
    });
  }
}
// e : 받은 면접제안

// 이력서 보기
const onClickMyResume = async (resumeId, ojfId, resOpenYn, applicantCnt, intvProposalCnt) => {
  const joinStateGb = jobDetail.value.joinStateGb;
  jobFairResumeModal.value.init(true, false, 0, 0, joinStateGb, applicantCnt, intvProposalCnt, 'openRecruitment');
  jobFairResumeModal.value.retrieveJobFairRecordDetail(resumeId, ojfId, resOpenYn);

  await jobFairResumeModal.value.show();

  ojfResumeList();
}

// 이력서 수정
const onClickChangeResume = (resumeId, ojfId) => {
  router.push({ name: 'MyPageJobFairResume', query : { resumeId: resumeId, ojfId: ojfId, mode: 'openRecruitment' }})
}

// 이력서 등록
const onClickResumeCreate = (id) => {
  router.push({ name: 'MyPageJobFairResumeCreate', query : { ojfId: id, mode: 'mypageOpenRecruitment' }});
}

// 이력서 삭제
const onClickDelete = async (resumeId, resOpenYn) => {
  let ok;
  if (resOpenYn === "Y") {
    ok = await $confirm(["인재정보에 공개된 이력서 입니다.", "그래도 이력서를 삭제하시겠습니까?"], "삭제", "취소");
  } else {
    ok = await $confirm(["이력서를 삭제하시겠습니까?"], "삭제", "취소");
  }

  if(!ok) {
    return -1;
  } else {
    jobFairUserService.ojfResumeDelete ( resumeId )
        .then((res) => {
          loadingStore.value = true;
          if(res.data.code.toLowerCase() === 'success') {
            if(resOpenYn === "Y") {
              $alert(["이력서가 삭제되었습니다.", "인재정보에 공개할 이력서를 다시 선택하세요."]);
              ojfResumeList();
            } else {
              $alert("이력서 삭제되었습니다.");
              ojfResumeList();
            }
          }
        }).catch( (error) =>  {
      loadingStore.loading = false;
    });
  }
}

// 채용공고 보기
const onClickJobNotice = async (jobNoticeSeq, corpId, applyStateGb) => {

  const ojfId = jobDetail.value.ojfId;

  let paramObj = {
    jobNoticeSeq: jobNoticeSeq,
  }

  jobFairUserService.ojfInterestJobNoticeYn(paramObj)
      .then( async (res) => {
        loadingStore.loading = false;
        if(res.data.code.toLowerCase() === 'success') {
          const result = res.data.result;
          if (applyStateGb) {
            const applyStateBtn = '지원함';
            jobNoticeModal.value.init(false, true, false, ojfId, 0, result, 0, applyStateBtn);
          } else {
            jobNoticeModal.value.init(false, true, false, ojfId, 0, result);
          }
          jobNoticeModal.value.ojfCropJobNoticeDetail(jobNoticeSeq);
          jobNoticeModal.value.ojfCorpRecruitmentHall(ojfId, corpId);
          jobNoticeModal.value.ojfCorporationDetail(corpId);
          await jobNoticeModal.value.show();

          ojfInterestJobNoticeList();
        } else {
          console.log(res);
        }
      }).catch( (res) =>  {
    loadingStore.loading = false;
    console.log(res);
  });
}

// 기업정보 보기
const onClickJob = async (corpId) => {

  const ojfId = jobDetail.value.ojfId;

  let paramObj = {
    ojfId: ojfId,
    corpId: corpId,
  }

  // 관심기업 유무
  jobFairUserService.ojfInterestHallEntryYn(paramObj)
      .then( async (res) => {
        loadingStore.loading = false;
        if(res.data.code.toLowerCase() === 'success') {
          const result = res.data.result;
          corpInfoModal.value.init(false, true, ojfId, result, undefined, 'mypageOpenRecruitment');
          corpInfoModal.value.ojfCorporationDetail(corpId);
          corpInfoModal.value.ojfGnbCorpInfoJobNoticeList(corpId, ojfId);
          await corpInfoModal.value.show();

          ojfInterestJobNoticeList();

        } else {
          console.log(res);
        }
      }).catch( (res) =>  {
    loadingStore.loading = false;
    console.log(res);
  });
}

// 입사지원 - 협회 이력서
const onClickApplicant = async (jobNoticeSeq, corpId) => {
  const ojfId = jobDetail.value.ojfId;
  // 이력서 등록 화면에서 이력서 등록 후지원 완료 시 마이페이지 이동하기 위한 데이터
  const mode = 'mypage';
  resumeListModal.value.init(0, mode);
  resumeListModal.value.ojfResumeListJobNoticeSeq(ojfId, jobNoticeSeq);

  await resumeListModal.value.show();

  ojfJobNoticeList(corpId); // 관심기업 > 채용공고
  ojfInterestJobNoticeList(); // 관심 공고
}

// 입사지원 - 회사 이력서
const onClickCorpApplicant = async (jobNoticeSeq, corpId) => {
  const ojfId = jobDetail.value.ojfId;
  // 회사이력서 양식 안내 팝업
  const ok = await applyResumeConfirmModal.value.show();

  if(ok) {
    applyResumeModal.value.init(ojfId, jobNoticeSeq);
    await applyResumeModal.value.show();

    ojfJobNoticeList(corpId); // 관심기업 > 채용공고
    ojfInterestJobNoticeList(); // 관심 공고
  }
}

</script>

<template>
  <div class="container">
    <div class="inner">
      <div class="flex-wrap">
        <SNB class="snb" />
        <!-- S : 강의 상세-->
        <div class="content">
          <div class="lecture-wrap">
            <div class="sub-title grid space-between">
              <h3>
                <span class="badge" :class="{'jobstate0': (jobDetail.ojfStateGb === '00' || jobDetail.ojfStateGb === '02'), 'jobstate2': jobDetail.ojfStateGb === '01', 'jobstate4': jobDetail.ojfStateGb === '03', 'jobstate5': jobDetail.ojfStateGb === '04'}">
                  {{ jobDetail.ojfStateGb === '00' ? '신청 대기' : jobDetail.ojfStateGb === '01' ? '신청 접수중' : jobDetail.ojfStateGb === '02' ? '신청마감' : jobDetail.ojfStateGb === '03' ? '행사 진행중' : '행사 종료' }}
                  <!-- 상태가 '03'일 때 -->
                  <span v-if="jobDetail.ojfStateGb === '03'">
                    {{ $isInRegPeriod(jobDetail.regStartYmd, jobDetail.regEndYmd) ? '(신청 접수중)' : ($isAfterRegEnd(jobDetail.regEndYmd) ? '(신청 마감)' : '') }}
                  </span>
                </span>{{ jobDetail.ojfName }}
              </h3>
              <div class="btn-wrap">
                <KSASecondaryButton class="gray_button" text="목록" @click="router.push({name: 'MyPageOpenRecruitment'})" />
              </div>
            </div>
            <div class="lecture-summary">
              <div class="left-area">
                <div class="img">
                  <KSAImage :src="jobDetail.ojfThombDir"/>
                </div>
              </div>
              <div class="right-area btn-area">
                <div class="btn-wrap">
                  <KSASecondaryButton text="행사 상세 보기" @click="router.push({name: 'MatchingOpenRecruitmentDetail', params:{id: jobDetail.ojfId}})" />
                </div>
                <div class="info">
                  <p>
                    <span class="badge" :class="{'jobstate1': (jobDetail.joinStateGb === '03' || jobDetail.joinStateGb === '04'), 'jobstate2': jobDetail.joinStateGb === '01', 'jobstate3': jobDetail.joinStateGb === '02', 'jobstate4': jobDetail.joinStateGb === '11', 'jobstate5': jobDetail.joinStateGb === '21'}">{{ $gbNameKR('USER_JOIN_STATE_GB', jobDetail.joinStateGb) }}</span>
                  </p>
                  <p>
                    <span>접수기간</span>
                    <span v-if="jobDetail.regStartYmd && jobDetail.regEndYmd">{{ $yyyymmdd(jobDetail.regStartYmd) }} ~ {{ $yyyymmdd(jobDetail.regEndYmd) }}</span>
                    <span v-else>-</span>
                  </p>
                  <p>
                    <span>행사기간</span>
                    <span v-if="jobDetail.ojfStartYmd && jobDetail.ojfEndYmd">{{ $yyyymmdd(jobDetail.ojfStartYmd) }} ~ {{ $yyyymmdd(jobDetail.ojfEndYmd) }}</span>
                    <span v-else>-</span>
                  </p>
                  <p>
                    <span>면접기간</span>
                    <span>{{ jobDetail.ojfIntvDay || '-' }}</span>
                  </p>
                  <p>
                    <span>장소</span>
                    <span>{{ jobDetail.ojfPlace || '-' }}</span>
                  </p>
                  <p>
                    <span>주최</span>
                    <span>{{ jobDetail.ojfHost || '-' }}</span>
                  </p>
                  <p v-if="jobDetail.summary">
                    <small class="mt-sm">*{{ jobDetail.summary }}</small>
                  </p>
                </div>
              </div>
            </div>
            <KSATab class="tab-style_border" :options="tabOptions" :disabled="isDisabled" @change="onSelectTab"/>
            <div class="lecture-detail" v-show="viewMode === JOB_FAIR">
              <!-- s : 행사정보 -->
              <div v-if="tabIndex === 0">
                <div class="editor-wrap" v-html="jobDetail.ojfIntro"></div>
              </div>
              <!-- e : 행사정보 -->

              <!-- s : 참가신청 정보 관리 -->
              <div class="table-form" v-if="tabIndex === 1">
                <div class="state-box">
                  현재 참가 신청 상태 : <span>{{ $gbNameKR('USER_JOIN_STATE_GB', entryDetail.joinStateGb) }}</span>
                </div>
                <table class="vertical align-left">
                  <colgroup>
                    <col width="20%" />
                    <col />
                  </colgroup>
                  <tr>
                    <th colspan="2">참가신청 정보</th>
                  </tr>
                  <!-- ella : 참가 목적 숨김 요청 (20250904) -->
<!--                  <tr>-->
<!--                    <th>참가 목적</th>-->
<!--                    <td>{{ entryDetail.joinPurpose }}</td>-->
<!--                  </tr>-->
                  <tr>
                    <th>면접 가능일</th>
                    <td class="word-break-all">
                      <span v-if="entryDetail.intvInYn === 'Y' && isAllSelected">
                        전체 일정 가능
                        [{{ entryDetail.intvAbleDay }}]
                      </span>
                      <span v-else-if="entryDetail.intvInYn === 'Y'">{{ entryDetail.intvAbleDay }}</span>
                      <span v-else>면접 일정 조율</span>
                    </td>
                  </tr>
                </table>

                <div v-if="entryDetail.joinStateGb === '01' || entryDetail.joinStateGb === '02'" class="btn-wrap space-between mb-xs">
                  <KSASecondaryButton class="gray_button" text="신청 취소" @click="cancelEntry(entryDetail.entrySeq, '03')" />
                  <KSAPrimaryButton class="gray_button" text="수정" @click="setViewMode(ENTRY_UPDATE)" />
                </div>
              </div>
              <!-- e : 참가신청 정보 관리 -->

              <!-- s : 이력서 관리 및 입사지원 현황 -->
              <div class="table-form" v-if="tabIndex === 2">
                <div class="instructions mb-xs">
                  <p>기업공채관 인재정보에 공개 할 수 있는 <span class="red">이력서는 1개만 가능</span>합니다.</p>
                  <p><span class="red">지원 완료된 이력서는 공개 여부와 관계없이 기업 인사담당자가 열람 가능</span>합니다.</p>
                </div>
                <div class="list-top mb-n-xs">
                  <KSAPrimaryButton text="이력서 등록" @click="onClickResumeCreate(jobDetail.ojfId)" />
                </div>
                <div class="list-top">
                  <p>총 게시물 <span>{{ $number(totalCount)}}</span>건</p>
                  <KSASelect :options="pageSizeGroup" class="select" @selectOption="onSelectPageSize"/>
                </div>
                <div class="table-form">
                  <table class="table-form board-mobile-vertical" v-if="resumeList !== null">
                    <tr>
                      <th>번호</th>
                      <th>내 이력서 제목</th>
                      <th>입사지원</th>
                      <th>최근 수정일</th>
                      <th>등록일</th>
                      <th>관리</th>
                      <th>인재정보 공개</th>
                    </tr>
                    <tr v-for="list in resumeList">
                      <td>{{ list.boardNo }}</td>
                      <td>
                        <p class="text-overflow long-overflow" v-if="list.fileYn === 'Y'" v-for="eduHist in list.resumeAttaches">
                          <KSATextButton :text="list.title" @click="$downloadForPrivate({fileName:eduHist.fileName, fileDir: eduHist.fileDir })" />
                        </p>
                        <p v-else class="clickable blue text-overflow long-overflow" @click="onClickMyResume(list.resumeId, list.ojfId, list.resOpenYn, list.applicantCnt, list.intvProposalCnt)">
                          {{ list.title }}
                        </p>
                      </td>
                      <td class="clickable blue" @click="setViewMode(RETRIEVE_APPLICANT, list.resumeId, list.resOpenYn, list.fileYn)">{{ list.applicantCnt }}</td>
                      <td>{{ $yyyymmddHHmmss(list.modifyDate) }}</td>
                      <td>{{ $yyyymmddHHmmss(list.createDate) }}</td>
                      <td>
                        <!-- 면접제안을 수락/거절했을 경우 수정 불가, 삭제 불가 -->
                        <div v-if="list.intvProposalCnt === 0">
                            <!-- 승인/반려 처리 이전(01 신청 접수 완료 02 신청 검토중) = 수정가능, 삭제 불가 -->
                            <div v-if="jobDetail.joinStateGb === '01' || jobDetail.joinStateGb === '02'">
                                <KSATextButton class="clickable" text="수정" @click="onClickChangeResume(list.resumeId, list.ojfId)"/>
                            </div>
                            <!-- 승인처리 이후(11) -->
                            <div v-else-if="jobDetail.joinStateGb === '11'">
                                <!-- 승인처리 이후(11) + 입사지원 없는 경우 = 수정가능, 삭제 가능 -->
                                <div v-if="list.applicantCnt === 0">
                                    <KSATextButton class="clickable mr-xs" text="수정" @click="onClickChangeResume(list.resumeId, list.ojfId)"/>
                                    <KSATextButton class="clickable red_button" text="삭제" @click="onClickDelete(list.resumeId, list.resOpenYn)"/>
                                </div>
                                <div v-else>-</div>
                            </div>
                            <!-- 반려 처리 이후(21) = 수정가능(의미없음), 삭제 가능 -->
                            <div v-else-if="jobDetail.joinStateGb === '21'">
                                <KSATextButton class="clickable mr-xs" text="수정" @click="onClickChangeResume(list.resumeId, list.ojfId)"/>
                                <KSATextButton class="clickable red_button" text="삭제" @click="onClickDelete(list.resumeId, list.resOpenYn)"/>
                            </div>
                            <!-- 면접제안을 수락/거절했을 경우 수정 불가, 삭제 불가 -->
                            <div v-else>-</div>
                        </div>
                        <div v-else>-</div>
                      </td>
                      <td>
                        <span v-if="list.resOpenYn === 'Y'">
                          <img src="../../../../../assets/images/toggle_on.png" @click="onClickChangeResOpenYn(list.resumeId, 'N')" style="cursor:pointer;" />
                        </span>
                        <span v-else>
                          <span v-if="list.resOpenYn === 'Y'">-</span>
                          <span v-else>
                            <img src="../../../../../assets/images/toggle_off.png" @click="onClickChangeResOpenYn(list.resumeId, 'Y')" style="cursor:pointer;" />
                          </span>
                        </span>
                      </td>
                    </tr>
                  </table>
                </div>
                <div class="result-none lecture-none" v-if="resumeList.length === 0">
                  등록된 이력서 및 입사지원이 없습니다.
                </div>
                <Paginate
                    v-if="resumeList.length > 0"
                    v-model="currentPage"
                    :page-count="totalPages"
                    :click-handler="onSelectPage"
                />
              </div>
              <!-- e : 이력서 관리 및 입사지원 현황 -->

              <!-- s : 관심 기업 -->
              <div class="table-form" v-if="tabIndex === 3">
                <div class="list-top">
                  <p>총 게시물 <span>{{ $number(totalCount)}}</span>건</p>
                  <KSASelect :options="pageSizeGroup" class="select" @selectOption="onSelectPageSize"/>
                </div>
                <div class="table-form">
                  <table class="table-form board-mobile-vertical" v-if="interestCorpList !== null">
                    <tr>
                      <th>번호</th>
                      <th>기업명</th>
                      <th>기업형태</th>
                      <th>산업군</th>
                      <th>업종</th>
                      <th>채용공고</th>
                      <th>관심 등록일</th>
                      <th>관심 삭제</th>
                    </tr>
                    <tr v-for="list in interestCorpList">
                      <td>{{ list.boardNo }}</td>
                      <td class="clickable blue" @click="onClickJob(list.corpId)">{{ list.corpName }}</td>
                      <td>{{ $gbNameKR('CORP_GB', list.corpGb) }}</td>
                      <td>{{ $gbNameKR('INDUSTRY_GB', list.industryGb) }}</td>
                      <td>{{ list.bizType }}</td>
                      <td @click="setViewMode(JOB_NOTICE_LIST, list.corpId)" class="clickable blue">
                        {{ list.jobNoticeCnt }}
                      </td>
                      <td>{{ $yyyymmddHHmmss(list.modifyDate) }}</td>
                      <td>
                        <KSATextButton text="♥" @click="onClickCorpEntryYn(list.corpId)" class="red_button" />
                      </td>
                    </tr>
                  </table>
                </div>
                <div class="result-none lecture-none" v-if="interestCorpList.length === 0">
                  등록된 관심기업이 없습니다.
                </div>
                <Paginate
                    v-if="interestCorpList.length > 0"
                    v-model="currentPage"
                    :page-count="totalPages"
                    :click-handler="onSelectPage"
                />
              </div>
              <!-- e : 관심 기업 -->

              <!-- s : 관심 공고 -->
              <div class="table-form" v-if="tabIndex === 4">
                <div class="list-top">
                  <p>총 게시물 <span>{{ $number(totalCount)}}</span>건</p>
                  <KSASelect :options="pageSizeGroup" class="select" @selectOption="onSelectPageSize"/>
                </div>
                <div class="table-form">
                  <table class="table-form board-mobile-vertical" v-if="interestNoticeList !== null">
                    <tr>
                      <th>번호</th>
                      <th>기업명</th>
                      <th>채용공고 제목</th>
                      <th>관심 카테고리</th>
                      <th>면접 가능일</th>
                      <th>면접 방식</th>
                      <th>관심 등록일</th>
                      <th>입사지원</th>
                      <th>관심삭제</th>
                    </tr>
                    <tr v-for="list in interestNoticeList">
                      <td>{{ list.boardNo }}</td>
                      <td class="clickable blue" @click="onClickJob(list.corpId)">{{ list.corpName }}</td>
                      <td class="clickable blue text-overflow long-overflow" @click="onClickJobNotice(list.jobNoticeSeq, list.corpId)">{{ list.jobName }}</td>
                      <td>{{ list.interests }}</td>
                      <td class="word-break-all">
                        <span v-if="list.intvInYn === 'Y' && isAllSelected4">
                          전체 일정 가능
                          [{{ list.intvAbleDay }}]
                        </span>
                        <span v-else-if="list.intvInYn === 'Y'">{{ list.intvAbleDay }}</span>
                        <span v-else>면접 일정 조율</span>
                      </td>
                      <td>{{ $gbNameKR('INTV_GB', list.intvGb) }}</td>
                      <td>{{ $yyyymmddHHmmss(list.modifyDate) }}</td>
                      <td>
                        <span v-if="list.applyStateGb" class="gray">지원완료</span>
                        <div v-else>
                          <!-- 회사 이력서 입사지원 -->
                          <span v-if="list.fileYn === 'Y'" class="clickable blue" @click="onClickCorpApplicant(list.jobNoticeSeq, list.corpId)">입사지원</span>
                          <!-- 협회 이력서 입사지원 -->
                          <span v-else class="clickable blue" @click="onClickApplicant(list.jobNoticeSeq, list.corpId)">입사지원</span>
                        </div>
                      </td>
                      <td>
                        <KSATextButton text="♥" @click="onClickNoticYn(list.jobNoticeSeq)" class="red_button"></KSATextButton>
                      </td>
                    </tr>
                  </table>
                </div>
                <div class="result-none lecture-none" v-if="interestNoticeList.length === 0">
                  등록된 관심공고가 없습니다.
                </div>
                <Paginate
                    v-if="interestNoticeList.length > 0"
                    v-model="currentPage"
                    :page-count="totalPages"
                    :click-handler="onSelectPage"
                />
              </div>
              <!-- e : 관심 공고 -->

              <!-- s : 받은 면접제안 -->
              <div class="table-form" v-if="tabIndex === 5">
                <div class="list-top">
                  <p>총 게시물 <span>{{ $number(totalCount)}}</span>건</p>
                  <KSASelect :options="pageSizeGroup" class="select" @selectOption="onSelectPageSize"/>
                </div>
                <div class="table-form">
                  <table class="table-form board-mobile-vertical" v-if="proposalList !== null">
                    <tr>
                      <th>번호</th>
                      <th>기업명</th>
                      <th>채용공고 제목</th>
                      <th>관심 카테고리</th>
                      <th>면접 가능일</th>
                      <th>내 이력서 제목</th>
                      <th>제안 받은일</th>
                      <th>상태</th>
                      <th>상태변경</th>
                    </tr>
                    <tr v-for="list in proposalList">
                      <td>{{ list.boardNo }}</td>
                      <td class="clickable blue text-overflow" @click="onClickJob(list.corpId)">{{ list.corpName }}</td>
                      <td class="clickable blue text-overflow long-overflow" @click="onClickJobNotice(list.jobNoticeSeq, list.corpId)">{{ list.jobName }}</td>
                      <td>{{ list.interests }}</td>
                      <td class="word-break-all">
                        <span v-if="list.intvInYn === 'Y' && isAllSelected5">
                          {{ list.intvAbleDay }}
                        </span>
                        <span v-else-if="list.intvInYn === 'Y'">{{ list.intvAbleDay }}</span>
                        <span v-else>면접 일정 조율</span>
                      </td>
                      <td>
                        <p class="clickable blue text-overflow long-overflow" @click="onClickMyResume(list.resumeId, list.ojfId, list.resOpenYn)">
                          {{ list.title }}
                        </p>
                      </td>
                      <td>{{ $yyyymmddHHmmss(list.createDate) }}</td>
                      <td>
                        <span v-if="list.intvPropStateGb === '01'">{{ $gbNameKR('USER_INTV_PROP_STATE_GB',list.intvPropStateGb) }}</span>
                        <span v-else-if="list.intvPropStateGb === '02' || list.intvPropStateGb === '05'" class="blue">{{ $gbNameKR('USER_INTV_PROP_STATE_GB',list.intvPropStateGb) }}</span>
                        <span v-else-if="list.intvPropStateGb === '03' || list.intvPropStateGb === '06'" class="red">{{ $gbNameKR('USER_INTV_PROP_STATE_GB',list.intvPropStateGb) }}</span>
                        <span v-else class="gray">{{ $gbNameKR('USER_INTV_PROP_STATE_GB',list.intvPropStateGb) }}</span>
                      </td>
                      <td>
                        <div v-if="list.intvPropStateGb === '01'">
                          <KSATextButton text="제안수락" @click="onClickIntvPropState(list.resumeId, list.jobNoticeSeq, '02')" class="clickable black_button"></KSATextButton><br/>
                          <KSATextButton text="제안거절" @click="onClickIntvPropState(list.resumeId, list.jobNoticeSeq, '03')" class="clickable black_button"></KSATextButton>
                        </div>
                        <div v-else>-</div>
                      </td>
                    </tr>
                  </table>
                </div>
                <div class="result-none lecture-none" v-if="proposalList.length === 0">
                  등록된 면접제안이 없습니다.
                </div>
                <Paginate
                    v-if="proposalList.length > 0"
                    v-model="currentPage"
                    :page-count="totalPages"
                    :click-handler="onSelectPage"
                />
              </div>
              <!-- e : 받은 면접제안 -->
            </div>
            <div class="lecture-detail" v-show="viewMode !== JOB_FAIR">
              <!-- S : 참가신청 정보 수정 -->
              <div class="table-form" v-if="viewMode === ENTRY_UPDATE">
                <div class="state-box">
                  현재 참가 신청 상태 : <span>{{ $gbNameKR('USER_JOIN_STATE_GB', entryDetail.joinStateGb) }}</span>
                </div>
                <table class="vertical align-left">
                  <colgroup>
                    <col width="20%" />
                    <col />
                  </colgroup>
                  <tr>
                    <th colspan="2">참가 신청 정보</th>
                  </tr>
                  <!-- ella : 참가 목적 숨김 요청 (20250904) -->
<!--                  <tr>-->
<!--                    <th class="mark">참가 목적</th>-->
<!--                    <td>-->
<!--                      <KSAInput v-model="entryDetail.joinPurpose" placeholder="ex) 취업 기회 탐색, 채용 정보 획득, 기업의 인사 담당자 또는 채용 관계자와의 네트워킹 등" />-->
<!--                      <p>-->
<!--                        <small style="color:#E71414;">{{ entryInputError.joinPurpose }}</small>-->
<!--                      </p>-->
<!--                    </td>-->
<!--                  </tr>-->
                  <tr>
                    <th rowspan="2">
                      <span class="mark">면접 가능일</span>
                    </th>
                    <td>
                      <ul class="grid category-wrap">
                        <li :class="{'active': isAllActive}" @click="onClickAll(false)">전체 일정 가능</li>
                        <li :class="{'active': day.on, 'disabled': isAllActive}" v-for="day in intvDays" @click="onClickIntvDay(day)">
                          {{ day.label }}
                        </li>
                      </ul>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <ul class="grid category-wrap">
                        <li :class="{'active': isEtcActive}" @click="onClickEtc(false)">면접 일정 조율</li>
                      </ul>
                      <p>
                        <small style="color:#E71414;">{{ entryInputError.intvAbleDay }}</small>
                      </p>
                    </td>
                  </tr>
                </table>
                <div class="btn-wrap space-between">
                  <KSASecondaryButton class="gray_button" text="취소" @click="cancelUpdateEntry" />
                  <KSASecondaryButton text="수정 완료" @click="ojfUpdateEntry" />
                </div>
              </div>
              <!-- E : 참가신청 정보 수정 -->
              <!-- S : 입사지원 목록 -->
              <div v-if="viewMode === RETRIEVE_APPLICANT">
                <div class="list-top mb-n-xs">
                  <KSASecondaryButton text="이전" @click="setViewMode(JOB_FAIR)" />
                </div>
                <div class="list-top">
                  <p>총 게시물 <span>{{ $number(totalCountDepth2)}}</span>건</p>
                  <KSAPrimaryButton v-if="fileYns === 'N'" text="이력서 보기" @click="onClickMyResume(detailCommonId, jobDetail.ojfId, detailResOpenYn)" />
                </div>
                <div class="table-form">
                  <table class="table-form board-mobile-vertical" v-if="applicantList !== null">
                    <tr>
                      <th>번호</th>
                      <th>기업명</th>
                      <th>채용공고 제목</th>
                      <th>관심 카테고리</th>
                      <th>면접 가능일</th>
                      <th>면접 방식</th>
                      <th>입사 지원일</th>
                      <th>상태</th>
                      <th>상태변경</th>
                    </tr>
                    <tr v-for="list in applicantList">
                      <td>{{ list.boardNo }}</td>
                      <td class="clickable blue" @click="onClickJob(list.corpId)">{{ list.corpName }}</td>
                      <td class="clickable blue" @click="onClickJobNotice(list.jobNoticeSeq, list.corpId, list.applyStateGb)">{{ list.jobName }}</td>
                      <td>{{ list.interests }}</td>
                      <td class="word-break-all text-left">
                        <span v-if="list.intvInYn === 'Y' && isAllSelected2">
                          전체 일정 가능
                          [{{ list.intvAbleDay }}]
                        </span>
                        <span v-else-if="list.intvInYn === 'Y'">{{ list.intvAbleDay }}</span>
                        <span v-else>면접 일정 조율</span>
                      </td>
                      <td>{{ $gbNameKR('INTV_GB', list.intvGb) }}</td>
                      <td>{{ $yyyymmddHHmmss(list.createDate) }}</td>
                      <td>
                        <span v-if="list.applyStateGb === '01'">{{ $gbNameKR('APPLY_STATE_GB',list.applyStateGb) }}</span>
                        <span v-else-if="list.applyStateGb === '03' || list.applyStateGb === '05'" class="blue">{{ $gbNameKR('APPLY_STATE_GB',list.applyStateGb) }}</span>
                        <span v-else-if="list.applyStateGb === '04' || list.applyStateGb === '06'" class="red">{{ $gbNameKR('APPLY_STATE_GB',list.applyStateGb) }}</span>
                        <span v-else class="gray">{{ $gbNameKR('APPLY_STATE_GB',list.applyStateGb) }}</span>
                      </td>
                      <td>
                        <div v-if="list.applyStateGb === '01'">
                          <KSATextButton class="clickable black_button" text="지원취소" @click="onClickApplyStateGb(list.resumeId, list.jobNoticeSeq, list.applyStateGb)"/>
                        </div>
                        <div v-else>
                          -
                        </div>
                      </td>
                    </tr>
                    <tr v-if="applicantList.length === 0">
                      <td colspan="9">입사 지원 내역이 없습니다.</td>
                    </tr>
                  </table>
                  <Paginate
                      v-if="applicantList.length > 0"
                      v-model="currentPageDepth2"
                      :page-count="totalPagesDepth2"
                      :click-handler="() => onSelectPage(currentPageDepth2, 2)"
                  />
                </div>
              </div>
              <!-- E : 입사지원 목록 -->
              <!-- S : 채용 공고 목록 -->
              <div class="table-form" v-if="viewMode === JOB_NOTICE_LIST">
                <div class="list-top mb-n-xs">
                  <KSASecondaryButton text="이전" @click="setViewMode(JOB_FAIR)" />
                </div>
                <div class="list-top">
                  <p>총 게시물 <span>{{ $number(totalCountDepth2)}}</span>건</p>
                  <KSAPrimaryButton text="기업정보 보기" @click="onClickJob(detailCommonId)" />
                </div>
                <table class="table-form board-mobile-vertical" v-if="jobNoticeList !== null">
                  <tr>
                    <th>번호</th>
                    <th>채용공고 제목</th>
                    <th>관심 카테고리</th>
                    <th>면접 가능일</th>
                    <th>면접 방식</th>
                    <th>채용공고 등록일</th>
                    <th>입사지원</th>
                  </tr>
                  <tr v-for="list in jobNoticeList">
                    <td>{{ list.boardNo }}</td>
                    <td class="clickable blue text-overflow long-overflow" @click="onClickJobNotice(list.jobNoticeSeq, list.corpId)">{{ list.jobName }}</td>
                    <td>{{ list.interests }}</td>
                    <td class="word-break-all text-left">
                      <span v-if="list.intvInYn === 'Y' && isAllSelected3">
                        전체 일정 가능
                        [{{ list.intvAbleDay }}]
                      </span>
                      <span v-else-if="list.intvInYn === 'Y'">{{ list.intvAbleDay }}</span>
                      <span v-else>면접 일정 조율</span>
                    </td>
                    <td>{{ $gbNameKR('INTV_GB', list.intvGb) }}</td>
                    <td>{{ $yyyymmddHHmmss(list.createDate) }}</td>
                    <td>
                      <span v-if="list.applyStateGb" class="gray">지원완료</span>
                      <div v-else>
                        <!-- 회사 이력서 입사지원 -->
                        <span v-if="list.fileYn === 'Y'" class="clickable blue" @click="onClickCorpApplicant(list.jobNoticeSeq, list.corpId)">입사지원</span>
                        <!-- 협회 이력서 입사지원 -->
                        <span v-else class="clickable blue" @click="onClickApplicant(list.jobNoticeSeq, list.corpId)">입사지원</span>
                      </div>
                    </td>
                  </tr>
                  <tr v-if="jobNoticeList.length === 0">
                    <td colspan="7">등록된 채용공고가 없습니다.</td>
                  </tr>
                </table>
                <Paginate
                    v-if="jobNoticeList.length > 0"
                    v-model="currentPageDepth2"
                    :page-count="totalPagesDepth2"
                    :click-handler="() => onSelectPage(currentPageDepth2, 2)"
                />
              </div>
              <!-- E : 관심 기업 채용 공고 -->
            </div>
          </div>
        </div>
        <!-- E : 강의 상세-->
      </div>
    </div>
  </div>
  <JobFairResumeOpenModal ref="jobFairResumeOpenModal" :showButtons="false" /> <!-- 텍스트 색상을 위한 디자인 팝업 -->
  <LecturePlayerModal ref="lecturePlayerModal" />
  <LectureResumeModal ref="lectureResumeModal" :showButtons="false"/>
  <LectureSurveyModal ref="lectureSurveyModal" />
  <JobFairResumeModal ref="jobFairResumeModal" />
  <JobFairJobNoticeModal ref="jobNoticeModal" /> <!-- 채용공고 보기 -->
  <JobFairCorpInfoModal ref="corpInfoModal" /> <!-- 기업정보 보기 -->
  <JobFairResumeListModal ref="resumeListModal" /> <!-- 이력서 목록 보기 -->
  <JobFairApplyResumeConfirmModal ref="applyResumeConfirmModal" :okButtonText="okButtonText" :cancelButtonText="cancelButtonText"/> <!-- 회사 이력서 안내 -->
  <JobFairApplyResumeModal ref="applyResumeModal" /> <!-- 회사 이력서 입사지원 -->
</template>

<style lang="scss" scoped>
@import "../../../../../assets/scss/theme";

.blue {
  color: $blue_color;
}

.category-wrap {
  .disabled {
    background: $gray-light_color;
    cursor: default;
  }
}

.instructions {
  background: $gray-regular_color;
  padding: 20px;
  p {
    &:before {
      content: "ㆍ";
    }
    .red {
      display: inline-block;
      color: $red_color;
    }
  }
}

.state-box {
  border: 2px solid $black_color;
  border-bottom: 0;
  padding: 10px 20px;
  span {
    color: $blue_color;
  }
}
.table-form {
  table {
    &.vertical {
      &.align-left {
        th {
          text-align: left;
          span {
            display: block;
            font-size: $font-size_xs;
            color: $gray_color;
            font-weight: normal;
            &.mark {
              font-size: $font-size_sm;
              color: $black_color;
              font-weight: bold;
            }
          }
        }
      }
    }
  }
  .clickable {
    text-decoration: underline;
    cursor: pointer;
  }
}
.board-detail {
  .header {
    border-top: 0;
  }
  .table-form {
    table {
      border-top: 0;
    }
  }
}
</style>
